/**
 * @generated SignedSource<<80fe582c2cebcf707d035b27bd4ee47a>>
 * @relayHash 52a1780a4db3ef2501ee48d54ffa8a1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b8295853745181bd23267965a269c9646cc295b42d4236212b5283e4cea3b55

import type { ConcreteRequest, Query } from 'relay-runtime';
export type lossAversionModalQuery$variables = {
  cloudId: string;
  isCCP: boolean;
};
export type lossAversionModalQuery$data = {
  readonly jira: {
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly __typename: "CommerceEntitlementInfoCcp";
      readonly entitlement: {
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePayment: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly chargeDetails?: {
            readonly chargeQuantities: ReadonlyArray<{
              readonly quantity: number | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type lossAversionModalQuery = {
  response: lossAversionModalQuery$data;
  variables: lossAversionModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCCP"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "applicationKey",
          "value": "JIRA_SOFTWARE"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "ScalarField",
      "name": "attachmentStorageUsed"
    }
  ]
},
v2 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software.ondemand"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v5 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "concreteType": "CcpChargeDetails",
  "kind": "LinkedField",
  "name": "chargeDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpChargeQuantity",
      "kind": "LinkedField",
      "name": "chargeQuantities",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "quantity"
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "lossAversionModalQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "experienceCapabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "configurePayment",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isCCP",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lossAversionModalQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "experienceCapabilities",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "configurePayment",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "CcpInvoiceGroup"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "CcpSubscription"
                      }
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "condition": "isCCP",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "CcpEntitlement",
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CommerceEntitlementInfoCcp"
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4b8295853745181bd23267965a269c9646cc295b42d4236212b5283e4cea3b55",
    "metadata": {},
    "name": "lossAversionModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f499aee268fbbbae058f6d4c13ba40dd";

export default node;
